import { ThemeOptions } from '@mui/material';

// Colors

const background = {
  default: '#F2F2F7',
  paper: '#fff',
};

const text = {
  primary: 'rgba(0, 0, 0, 0.87)',
  secondary: 'rgba(0, 0, 0, 0.6)',
  disabled: 'rgba(0, 0, 0, 0.38)',
};

export const lightThemeOptions: ThemeOptions = {
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          color: text.primary,
          backgroundColor: 'rgba(249, 249, 249, 0.94)',
        },
      },
    },
  },
  palette: {
    background,
  },
  diseaseGroupsColors: {
    IBD: {
      main: '#ab1a78',
      light: '',
      dark: '',
      contrastText: '#FFFFFF',
    },
    TCB: {
      main: '#0F4392',
      light: '',
      dark: '',
      contrastText: '#FFFFFF',
    },
    'TCB-F': {
      main: '#fff8d6',
      light: '',
      dark: '',
      contrastText: '#e76500',
    },
    SBS: {
      main: '#007749',
      light: '',
      dark: '',
      contrastText: '#FFFFFF',
    },
    ALF: {
      main: '#e1f4ff',
      light: '',
      dark: '',
      contrastText: '#0070f2',
    },
    RH: {
      main: '#E1242A',
      light: '',
      dark: '',
      contrastText: '#FFFFFF',
    },
    RI: {
      main: '#891515',
      light: '',
      dark: '',
      contrastText: '#FFFFFF',
    },
    RM: {
      main: '#A1A4AC',
      light: '',
      dark: '',
      contrastText: '#FFFFFF',
    },
    PDT: {
      main: '#F78C85',
      light: '',
      dark: '',
      contrastText: '#FFFFFF',
    },
    'CRC(VCT・FRU)': {
      main: '#00A1D4',
      light: '',
      dark: '',
      contrastText: '#FFFFFF',
    },
    NIN: {
      main: '#E47700',
      light: '',
      dark: '',
      contrastText: '#FFFFFF',
    },
    ADC: {
      main: '#BF1A42',
      light: '',
      dark: '',
      contrastText: '#FFFFFF',
    },
    ALB: {
      main: '#37A2B3',
      light: '',
      dark: '',
      contrastText: '#FFFFFF',
    },
    CAB: {
      main: '#1B568A',
      light: '',
      dark: '',
      contrastText: '#FFFFFF',
    },
    OC: {
      main: '#123B73',
      light: '',
      dark: '',
      contrastText: '#FFFFFF',
    },
    Vaccine: {
      main: '#DF5426',
      light: '',
      dark: '',
      contrastText: '#FFFFFF',
    },
  },
};
